import React from 'react';
import { connect } from 'react-redux';
import { withRenderFlag } from '@beef/react';
import { compose } from '@beef/redux';
import { Button } from '@beef/ui-kit';
import classNames from 'classnames/bind';
import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import { onDeviceClickMoreAnalitics } from "../../../../store/blocks/checkAddress/actions";
import { getDeviceAlias, getDeviceTexts, getDeviceTitle } from "../../../../store/blocks/devices/selectors";
import styles from "./styles.pcss";
var cx = classNames.bind(styles);
var _DeviceButtons = function _DeviceButtons(_ref) {
  var onClick = _ref.onClick,
    texts = _ref.texts;
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(cx('device-buttons')),
    "data-t-id": "components-DeviceButtons"
  }, /*#__PURE__*/React.createElement("div", {
    className: cx('device-buttons__container')
  }, /*#__PURE__*/React.createElement(Button, {
    fullWidth: true,
    onClick: onClick,
    size: "s",
    variant: "tertiary"
  }, texts.moreInfo)));
};
_DeviceButtons.propTypes = process.env.NODE_ENV !== "production" ? {
  onClick: PropTypes.func,
  texts: PropTypes.shape({
    add: PropTypes.string,
    moreInfo: PropTypes.string
  })
} : {};
var mapStateToProps = function mapStateToProps(state) {
  return {
    deviceAlias: getDeviceAlias(state),
    deviceTitle: getDeviceTitle(state),
    shouldRender: !isEmpty(getDeviceTexts(state).btnsContent),
    texts: getDeviceTexts(state).btnsContent
  };
};
var mapDispatchToProps = {
  onClick: onDeviceClickMoreAnalitics
};
export var DeviceButtons = compose(connect(mapStateToProps, mapDispatchToProps), withRenderFlag)(_DeviceButtons);